import "./Home.scss";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux"; // Add this import
import { Link } from "react-router-dom";
import UsersGif from "./../../assets/users-gif.gif";
import FactoriesProductsGif from "./../../assets/factories-products-gif.gif";
import ShopsGif from "./../../assets/shops-gif.gif";
import CartGif from "./../../assets/factories-gif.gif";
import MoneyGif from "./../../assets/money-gif.gif";
import ShowUser from "./../../assets/show-user.svg";
import { DataGrid } from "@mui/x-data-grid";
import { HomeColumns } from "../../SourceData";
import MessageModals from "../../components/MessageModals/MessageModals";
import SwipeableModals from "./SwipeableModals/SwipeableModals";
import api from "../../utils/api";
import Chart from "../../components/Chart/Chart";
import Loader from "../../components/Loader";
import { setNotificationCount } from "../../redux/notificationsSlice"; // Add this import
import { usePermissions } from "./../../hooks/usePermissions";

const Home = () => {
  const { hasPermission } = usePermissions();
  const dispatch = useDispatch(); // Add this hook
  const [homeData, setHomeData] = useState({});
  const [currentModalView, setCurrentModalView] = useState("changePassword");
  const [openDelete, setOpenDelete] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});

  const handleOpen = (view) => {
    setCurrentModalView(view);
    setIsOpen(true);
  };
  const handleClose = () => setIsOpen(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      const res = await api.get("/admin/getStats");
      const data = res.data.data;
      setHomeData(data);

      // Update notification counts in Redux store
      dispatch(
        setNotificationCount({
          key: "cancellationRequests",
          count: data.totalRefundsCount || 0,
        })
      );

      dispatch(
        setNotificationCount({
          key: "supportQuestions",
          count: data.supportQuestionsWithoutNotesCount || 0,
        })
      );

      dispatch(
        setNotificationCount({
          key: "changeAddressRequests",
          count: data.changeAddressRequestsCount || 0,
        })
      );

      dispatch(
        setNotificationCount({
          key: "previewRequests",
          count: data.previewRequestsCount || 0,
        })
      );
    } catch (error) {
      console.error("Error fetching stats:", error);
    } finally {
      setLoading(false);
      setUser("");
    }
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "",
      width: 180,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="cell-action">
            <Link className="cell-btn" to={`/users/${params.row._id}`}>
              <img src={ShowUser} alt="" />
            </Link>
          </div>
        );
      },
    },
  ];

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="home">
      <div className="widgets">
        {/* Users Widget - Permission ID: 2 */}
        {hasPermission(2) && (
          <Link className="widget" to="/users">
            <div
              className="icon-container"
              style={{ backgroundColor: "#ECF9FF" }}
            >
              <img src={UsersGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.usersCount || 0}</p>
              {/* <span className="percentage">25%+</span> */}
            </div>
            <span className="widget-title">عدد المستخدمين</span>
          </Link>
        )}

        {/* Departments Widget - Permission ID: 3 */}
        {hasPermission(3) && (
          <Link className="widget" to="/departments">
            <div
              className="icon-container"
              style={{ backgroundColor: "#ECF9FF" }}
            >
              <img src={FactoriesProductsGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.categoriesCount || 0}</p>
              {/* <span className="percentage">10%+</span> */}
            </div>
            <span className="widget-title">عدد الاقسام</span>
          </Link>
        )}

        {/* Services Widget - Permission ID: 4 */}
        {hasPermission(4) && (
          <Link className="widget" to="/services">
            <div
              className="icon-container"
              style={{ backgroundColor: "#FFF6EB" }}
            >
              <img src={ShopsGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.servicesCount || 0}</p>
              {/* <span className="percentage">10%+</span> */}
            </div>
            <span className="widget-title">عدد الخدمات</span>
          </Link>
        )}

        {/* Packages Widget - Permission ID: 5 */}
        {hasPermission(5) && (
          <Link className="widget" to="/packages">
            <div
              className="icon-container"
              style={{ backgroundColor: "#FEEEF6" }}
            >
              <img src={CartGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.subscriptionsCount || 0}</p>
            </div>
            <span className="widget-title">عدد الاشتراكات</span>
          </Link>
        )}

        {/* Workers Widget - Permission ID: 6 */}
        {hasPermission(6) && (
          <Link className="widget" to="/workers">
            <div
              className="icon-container"
              style={{ backgroundColor: "#ECF9FF" }}
            >
              <img src={UsersGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.techniciansCount || 0}</p>
            </div>
            <span className="widget-title">عدد العمال</span>
          </Link>
        )}

        {/* Orders Widget - Permission ID: 7 */}
        {hasPermission(7) && (
          <Link className="widget" to="/orders">
            <div
              className="icon-container"
              style={{ backgroundColor: "#ECF9FF" }}
            >
              <img src={FactoriesProductsGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.bookingsCount || 0}</p>
              {/* <span className="percentage">10%+</span> */}
            </div>
            <span className="widget-title">عدد الطلبات</span>
          </Link>
        )}

        {/* Revenue Widget - Permission ID: 8 */}
        {hasPermission(8) && (
          <div className="widget">
            <div
              className="icon-container"
              style={{ backgroundColor: "#ECF9FF" }}
            >
              <img src={MoneyGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.revenue || 0}</p>
              {/* <span className="percentage">10%+</span> */}
            </div>
            <span className="widget-title">الايرادات</span>
          </div>
        )}
      </div>

      {/* Chart Section - Permission ID: 9 */}
      {hasPermission(9) && (
        <>
          <h4>حالة الطلبات</h4>
          <Chart />
        </>
      )}

      {/* Recent Users DataGrid Section - Permission ID: 10 */}
      {hasPermission(10) && (
        <>
          <h4>المستخدمين المنضمين حديثاً</h4>
          <div className="data-grid">
            <DataGrid
              sx={{ backgroundColor: "white", width: "100%" }}
              autoHeight={true}
              columns={HomeColumns.concat(actionColumn)}
              rows={
                homeData?.recentUsers?.map((row, index) => {
                  return { ...row, id: row._id, index: index + 1 };
                }) || []
              }
              disableVirtualization
              disableColumnFilter
              disableColumnMenu
              loading={loading}
              hideFooter
            />
          </div>
        </>
      )}

      <MessageModals
        open={openDelete}
        currentView="delete"
        route={`/users/${user._id}`}
        onClose={() => {
          setOpenDelete(false);
        }}
        onDataChange={getData}
      />

      <SwipeableModals
        open={isOpen}
        onClose={handleClose}
        onOpen={handleOpen}
        currentView={currentModalView}
        user={user}
        onDataChange={getData}
      />
    </div>
  );
};

export default Home;
